export {
  mapFhirServiceRequestToModel,
  mapModelToFhirServiceRequest,
} from './pathologyOrder';
